import React, { createContext, useContext } from 'react';

const UserContext = createContext();

export const UserProvider = ({ children, userPermissions }) => {
    return (
        <UserContext.Provider value={userPermissions}>
            {children}
        </UserContext.Provider>
    );
};

export const useUserPermissions = () => useContext(UserContext);